import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gratiora_admin_token", data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-white border border-gold/20 px-4 py-3.5 text-sm text-ink placeholder:text-ink/40 focus:outline-none focus:border-gold transition-colors duration-300";

  return (
    <main className="min-h-screen flex items-center justify-center px-6 bg-cream">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center font-serif text-2xl tracking-[0.3em] font-medium text-ink">
          GRAT<span className="text-gold-brass">I</span>ORA
        </Link>
        <p className="mt-2 text-center eyebrow">Admin Studio</p>
        <form onSubmit={submit} className="mt-10 bg-white border border-gold/15 p-8 space-y-5">
          <div>
            <label className="eyebrow !text-[10px] block mb-2">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@gratiora.in"
              className={inputCls}
            />
          </div>
          <div>
            <label className="eyebrow !text-[10px] block mb-2">Password</label>
            <input
              data-testid="admin-passcode-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className={inputCls}
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-3">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="w-full bg-ink text-cream px-8 py-4 text-sm tracking-wide hover:bg-gold-brass transition-colors duration-400 disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
